module.exports = __webpack_public_path__ + "img/icon01.a75be932.png";